import cx from 'classnames';
import { BZ_IN_STOCK, WHERE_TO_BUY_ITEM_CTA } from 'mk/autogenerated/translations/StrollerDetailWhereToBuyListItem.447b206e6febc611d761de990eb1135b'
import { formatPrice } from 'mk/bazaar/common/formatters';
import { Btn, BtnType } from 'mk2/components/Btn';
import { Clamp } from 'mk2/components/Clamp';
import { ImgCropped, ImgCropMode } from 'mk2/components/ImgCropped';
import { Link } from 'mk2/components/Link';
import { PhotoEntity } from 'mk2/schemas';
import React from 'react';
import styles from './StrollerDetailWhereToBuyListItem.mscss';

interface OwnProps {
    logo: PhotoEntity;
    productUrl: string;
    productName: string;
    price: number | string;
    originalPrice: string;
    inStock?: boolean;
    isAdmin: boolean;
    isLast?: boolean;
    isMobile: boolean;
}

type Props = OwnProps;

export const StrollerDetailWhereToBuyListItem: React.FunctionComponent<Props> = React.memo(({
    logo,
    productName,
    productUrl,
    price,
    originalPrice,
    inStock,
    isAdmin,
    isLast = false,
    isMobile,
}) => {
    return (
        <div
            className={cx(styles.StrollerDetailWhereToBuyListItem, !isLast && styles['StrollerDetailWhereToBuyListItem--isNotLast'])}>
            <div className={styles.StrollerDetailWhereToBuyListItem__seller}>
                <Link to={productUrl} target="_blank">
                    <ImgCropped
                        width={isMobile ? 65 : 140}
                        height={30}
                        photo={logo}
                        photoVersion="s420x420"
                        mode={ImgCropMode.Embed}
                        anchorX="left"
                    />
                </Link>
                <div className={styles.StrollerDetailWhereToBuyListItem__price}>
                    <div title={isAdmin && originalPrice}
                        className={styles.StrollerDetailWhereToBuyListItem__priceNumber}>{price ? formatPrice(price) : '-'}</div>
                    {inStock &&
                        <div className={styles.StrollerDetailWhereToBuyListItem__priceInStock}>{BZ_IN_STOCK}</div>}
                </div>
                <div className={styles.StrollerDetailWhereToBuyListItem__product}>
                    <Btn type={BtnType.Blue} label={WHERE_TO_BUY_ITEM_CTA} link={productUrl} linkTarget="_blank"
                         asAnchor/>
                </div>
            </div>
            <Clamp clamp={2}>
                {productName && (
                    <div className={styles.StrollerDetailWhereToBuyListItem__productName}>
                        {productName}
                    </div>
                )}
            </Clamp>
        </div>
    );
});

StrollerDetailWhereToBuyListItem.displayName = 'StrollerDetailWhereToBuyListItem';
